import { MediaLibraryState } from '../types'
import {
  MediaLibraryImageItem,
  MediaLibraryEssence,
} from '@/types/mediaLibrary'

const imagesMediaLibrary =
  (state: MediaLibraryState) =>
  (essence: MediaLibraryEssence): MediaLibraryImageItem[] => {
    return state.value.get(essence)?.images ?? []
  }

export default imagesMediaLibrary
